import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import moment, { Moment } from "moment";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";
import DateComIntervalo from "../../../../../../../../components/DateComIntervalo";
import SelectFuncoes from "../../../../../../../../components/SelectsSimpleApiQuery/SelectFuncao";
import SelectTipoDocReceber from "../../../../../../../../components/SelectsSimpleApiQuery/SelectTipoDocReceber";
import SelectSituacaoFinanceira from "../../../../../../../../components/SelectsSimpleApiQuery/SelectSituacaoFinanceira";
export default function TitReceberAberto({
  open,
  defaultValue,
  onClose,
  onSubmitFiltros,
}: TitReceberAbertoProps) {

  const [titReceberFiltros, setTitReceberFiltros] = useState<TTitReceberFiltros>({
    considera_titulos: defaultValue.considera_titulos ?? "Sim",
    funcao: defaultValue.funcao,
    situacao: defaultValue.situacao,
    tipo_documento: defaultValue.tipo_documento,
    periodo_emissao_inicio: defaultValue.periodo_emissao_inicio ? moment(defaultValue.periodo_emissao_inicio) : null,
    periodo_emissao_fim: defaultValue.periodo_emissao_fim ? moment(defaultValue.periodo_emissao_fim) : null,
    periodo_vencimento_inicio: defaultValue.periodo_vencimento_inicio ? moment(defaultValue.periodo_vencimento_inicio) : null,
    periodo_vencimento_fim: defaultValue.periodo_vencimento_fim ? moment(defaultValue.periodo_vencimento_fim) : null,
  });

  const handleChangeReceberFiltros = (name: string, value: any) => {
    setTitReceberFiltros(prevState => ({ ...prevState, [name]: value }));
  }

  const handleSubmit = useCallback(() => {
    onSubmitFiltros({
      funcao: titReceberFiltros.funcao?.map((item: any) => ({ id: item.id, nome: item.nome })),
      tipo_documento: titReceberFiltros.tipo_documento?.map((item: any) => ({ id: item.id, nome: item.nome })),
      situacao: titReceberFiltros.situacao?.map((item: any) => ({ id: item.id, nome: item.nome })),
      periodo_emissao_inicio: titReceberFiltros.periodo_emissao_inicio?.format('YYYY-MM-DD'),
      periodo_emissao_fim: titReceberFiltros.periodo_emissao_fim?.format('YYYY-MM-DD'),
      periodo_vencimento_inicio: titReceberFiltros.periodo_vencimento_inicio?.format('YYYY-MM-DD'),
      periodo_vencimento_fim: titReceberFiltros.periodo_vencimento_fim?.format('YYYY-MM-DD'),
      considera_titulos: titReceberFiltros.considera_titulos
    });
    onClose();
  }, [titReceberFiltros, onClose, onSubmitFiltros]);

  const opcoesRadio = useMemo(() => [
    { value: "Sim", label: "Considerar" },
    { value: "Não", label: "Nenhum" },
  ], [])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={'xs'}
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
      fullWidth
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Títulos a receber em aberto</DialogTitle>
      <DialogContent>
        <Box mt={1} display={'flex'} flexDirection={'column'} gap={2}>
          <FormControl>
            <FormLabel id="consideraTitulo">Considerar títulos?</FormLabel>
            <RadioGroup
              row
              aria-labelledby="consideraTitulo"
              value={titReceberFiltros.considera_titulos}
              onChange={(e) => handleChangeReceberFiltros("considera_titulos", e.target.value)}
            >
              {
                opcoesRadio.map((opcao, index) => (
                  <FormControlLabel key={index} value={opcao.value} control={<Radio />} label={opcao.label} />
                ))
              }
            </RadioGroup>
          </FormControl>
          {
            titReceberFiltros.considera_titulos === "Sim" &&
            <>
              <DateComIntervalo
                data={{
                  inicial: (titReceberFiltros.periodo_emissao_inicio),
                  final: (titReceberFiltros.periodo_emissao_fim)
                }}
                onChangeData={(data) => {
                  handleChangeReceberFiltros("periodo_emissao_inicio", data.inicial)
                  handleChangeReceberFiltros("periodo_emissao_fim", data.final)
                }}
                datePickerView={['year', 'month', 'day']}
                formatString="DD/MM/YYYY"
                labelInput="Período de emissão"
                possuiBtnLimpar
              />
              <DateComIntervalo
                data={{
                  inicial: (titReceberFiltros.periodo_vencimento_inicio),
                  final: (titReceberFiltros.periodo_vencimento_fim)
                }}
                onChangeData={(data) => {
                  handleChangeReceberFiltros("periodo_vencimento_inicio", data.inicial)
                  handleChangeReceberFiltros("periodo_vencimento_fim", data.final)
                }}
                datePickerView={['year', 'month', 'day']}
                formatString="DD/MM/YYYY"
                labelInput="Período de vencimento"
                possuiBtnLimpar
              />
              <SelectFuncoes
                multiple
                possuiBtnLimpar
                value={titReceberFiltros.funcao}
                onChange={(valor) => handleChangeReceberFiltros('funcao', valor)}
                extraParams={{flg_considera_fechamento: true}}
              />
              <SelectTipoDocReceber
                multiple
                possuiBtnLimpar
                value={titReceberFiltros.tipo_documento}
                onChange={(valor) => handleChangeReceberFiltros('tipo_documento', valor)}
                extraParams={{flg_considera_fechamento: true}}
              />
              <SelectSituacaoFinanceira
                multiple
                possuiBtnLimpar
                value={titReceberFiltros.situacao}
                onChange={(valor) => handleChangeReceberFiltros('situacao', valor)}
                extraParams={{flg_considera_fechamento: true}}
              />
            </>
          }
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display={'flex'} gap={2}>
          <Button variant="outlined" onClick={onClose}>
            Fechar
          </Button>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Alterar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

interface TitReceberAbertoProps {
  open: boolean
  defaultValue: {
    periodo_emissao_inicio: string | null;
    periodo_emissao_fim: string | null;
    periodo_vencimento_inicio: string | null;
    periodo_vencimento_fim: string | null;
    funcao: any
    situacao: any
    tipo_documento: any
    considera_titulos: "Sim" | "Não" | null
  }
  onClose: () => void
  onSubmitFiltros: (value: any) => void
}

type TTitReceberFiltros = {
  periodo_emissao_inicio: Moment | null
  periodo_emissao_fim: Moment | null
  periodo_vencimento_inicio: Moment | null
  periodo_vencimento_fim: Moment | null
  funcao: any
  situacao: any
  tipo_documento: any
  considera_titulos: "Sim" | "Não" | null
}
